import React from 'react'
import { RefObject } from 'react'
import { CustomSVG } from '~components/ui/nucleons/custom-svg'

export const LinkedInSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG aria-hidden={ariaHidden} width="24" height="24" className={className} aria-label={ariaLabel}>
    <path
      d="M2 3.43267C2 2.64156 2.66178 2 3.478 2H20.522C21.3382 2 22 2.64156 22 3.43267V20.5673C22 21.3587 21.3382 22 20.522 22H3.478C2.66178 22 2 21.3587 2 20.5673V3.43267Z"
      fill="#2867B2"
    />
    <path
      d="M8.26128 6.91787C8.26128 7.78453 7.6055 8.47809 6.55217 8.47809H6.53261C5.51884 8.47809 4.86328 7.78453 4.86328 6.91787C4.86328 6.03164 5.53884 5.35742 6.57217 5.35742C7.60573 5.35742 8.24173 6.03164 8.26128 6.91787Z"
      fill="white"
    />
    <path
      d="M9.73427 18.7422H12.7552V13.6988C12.7552 13.4288 12.7747 13.1593 12.8545 12.9664C13.0729 12.427 13.5698 11.8686 14.4045 11.8686C15.4976 11.8686 15.9349 12.6968 15.9349 13.9108V18.7422H18.9554V13.5639C18.9554 10.7899 17.4652 9.49927 15.4776 9.49927C13.8753 9.49927 13.1567 10.3743 12.7552 10.9896V9.71105H9.73427C9.77382 10.5586 9.73427 18.7422 9.73427 18.7422Z"
      fill="white"
    />
    <path d="M8.06262 18.7422V9.71106H5.04173V18.7422H8.06262Z" fill="white" />
  </CustomSVG>
)

export const TwitterSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG aria-hidden={ariaHidden} width="24" height="24" className={className} aria-label={ariaLabel}>
    <path
      d="M8.28963 20.1257C15.8368 20.1257 19.9649 13.8728 19.9649 8.45048C19.9649 8.27292 19.9649 8.09603 19.9529 7.92003C20.756 7.33913 21.4491 6.62002 22 5.79601C21.2511 6.12779 20.4566 6.34557 19.6431 6.44157C20.4998 5.92867 21.1409 5.12222 21.4471 4.17199C20.6415 4.64999 19.7604 4.98689 18.8415 5.168C17.2875 3.51554 14.6881 3.43576 13.0357 4.98978C11.9699 5.99201 11.5179 7.48536 11.8486 8.91049C8.54963 8.74493 5.47559 7.18669 3.39202 4.6231C2.30289 6.49801 2.85912 8.89671 4.66247 10.1007C4.00936 10.0814 3.37068 9.90516 2.80001 9.58716C2.80001 9.60405 2.80001 9.6216 2.80001 9.63916C2.80045 11.5925 4.17736 13.2748 6.09205 13.6617C5.48804 13.8263 4.85403 13.8505 4.23914 13.7321C4.7767 15.4037 6.31716 16.5488 8.07273 16.5817C6.61961 17.7237 4.8247 18.3435 2.97668 18.3417C2.65023 18.341 2.32423 18.3213 2 18.2824C3.87647 19.4866 6.06005 20.1253 8.28963 20.1224"
      fill="#1DA1F2"
    />
  </CustomSVG>
)

export const EmailSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG aria-hidden={ariaHidden} width="24" height="24" className={className} aria-label={ariaLabel}>
    <circle cx="12" cy="12" r="12" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="white"
      d="M7.5 7.5H16.5H18V9V15V16.5H16.5H7.5H6V15V9V7.5H7.5ZM15.2225 9H8.77742L12 11.7622L15.2225 9ZM7.5 9.88068V15H16.5V9.88065L12 13.7378L7.5 9.88068Z"
    />
  </CustomSVG>
)

export const PhoneSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG aria-hidden={ariaHidden} className={className} aria-label={ariaLabel}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4.80115C0.694347 7.4012 2.06142 9.85898 4.10122 11.8988C6.14102 13.9386 8.5988 15.3057 11.1989 16L16 11.1989L11.8004 6.99928L9.78729 9.01243C9.27152 8.61103 8.77486 8.17329 8.30079 7.69921C7.82671 7.22514 7.38897 6.72848 6.98757 6.21271L9.00072 4.19957L4.80115 0L0 4.80115ZM6.201 4.19957L4.80115 2.79971L2.24449 5.35637C2.91267 7.23385 3.99819 8.99604 5.50108 10.4989C7.00396 12.0018 8.76615 13.0873 10.6436 13.7555L13.2003 11.1989L11.8004 9.799L10.0128 11.5866C8.9081 10.8905 7.86318 10.0613 6.90093 9.09907C5.93869 8.13682 5.10951 7.0919 4.41341 5.98716L6.201 4.19957Z"
    />
  </CustomSVG>
)

export const LocationSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG aria-hidden={ariaHidden} width="12" height="12" className={className} aria-label={ariaLabel}>
    <path d="M0 0H7.5V12H6V1.5H1.5V12H0V0Z" />
    <path d="M12 12V6H8.25V7.5H10.5V12H12Z" />
    <path d="M3 3H4.5V4.5H3V3Z" />
    <path d="M4.5 6H3V7.5H4.5V6Z" />
    <path d="M8.25 9H9.75V10.5H8.25V9Z" />
    <path d="M4.5 9H3V10.5H4.5V9Z" />
  </CustomSVG>
)

export const DownloadSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel}>
    <path d="M9.00183 0H7.00183V8.16843L3.75916 4.92578L2.34497 6.34L8.00183 11.9968L13.6587 6.34L12.2444 4.92578L9.00183 8.16841V0Z" />
    <rect y="14" width="16" height="2" />
  </CustomSVG>
)

export const EEDownloadSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.49999 5.24941L4.15206 5.25C4.45122 5.25 4.69778 5.47519 4.73147 5.7653L4.7354 5.83333L4.73147 5.90136C4.70037 6.16916 4.48789 6.38164 4.22009 6.41274L4.15206 6.41666L3.64582 6.41608C3.57679 6.41608 3.51896 6.46405 3.50384 6.52848L3.49999 6.56191L2.33332 11.5208C2.33332 11.5899 2.38129 11.6477 2.44572 11.6628L2.47916 11.6667H11.5208C11.5899 11.6667 11.6477 11.6187 11.6628 11.5543L11.6667 11.5208L10.5 6.5625C10.5 6.49346 10.452 6.43563 10.3876 6.42052L10.3542 6.41666H8.74999C8.45084 6.41666 8.20428 6.19147 8.17058 5.90136L8.16666 5.83333L8.17058 5.7653C8.20169 5.4975 8.41416 5.28503 8.68196 5.25392L8.74999 5.25L10.6265 5.25042L10.743 5.2534L10.8503 5.26148C11.1936 5.29974 11.398 5.46556 11.6045 6.1841L11.6667 6.41666L12.8333 11.6661C12.8333 12.2811 12.3574 12.785 11.7537 12.8295L11.6667 12.8327H2.33332C1.71828 12.8327 1.21439 12.3568 1.16986 11.7532L1.16666 11.6661L2.33332 6.41608C2.54999 5.54985 2.92761 5.3271 3.19136 5.2709L3.26679 5.25855L3.33374 5.25334L3.41292 5.25261L3.49999 5.24941ZM7.43579 1.16691L9.81658 1.24244L9.87637 1.24807C10.0899 1.28191 10.2376 1.45796 10.2339 1.6741L10.229 1.73397L9.88959 4.09202L9.87612 4.15522C9.82941 4.3209 9.69831 4.46167 9.52929 4.52206C9.36027 4.58246 9.18284 4.55193 9.06261 4.4459L9.02033 4.40262L8.50989 3.79431L8.49061 3.77653C8.45678 3.75258 8.41 3.75019 8.36909 3.76995L8.33981 3.78893L8.33816 3.78758L8.24379 3.86084C7.42482 4.52057 6.90082 5.5317 6.90082 6.66521C6.90082 7.39614 7.11871 8.07618 7.49307 8.64392C7.5941 8.7477 7.6611 8.88396 7.67818 9.03539L7.68249 9.12396C7.68249 9.47426 7.41745 9.76266 7.07695 9.79955L6.99124 9.80354C6.72886 9.80354 6.50122 9.65485 6.38796 9.43714L6.4706 9.55533C5.88594 8.74165 5.54166 7.74363 5.54166 6.66521C5.54166 5.06808 6.29678 3.64732 7.46949 2.74048L7.48512 2.72511C7.51342 2.68909 7.52102 2.64267 7.50526 2.60448L7.48901 2.57767L6.97857 1.96935L6.94639 1.9253C6.85944 1.78782 6.85903 1.60502 6.94909 1.44694C7.04916 1.27131 7.24125 1.16079 7.43579 1.16691Z"
    />
  </CustomSVG>
)

export const BackArrowSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel}>
    <path fillRule="evenodd" clipRule="evenodd" d="M10.6 1L12 2.4L6.4 8L12 13.6L10.6 15L3.6 8L10.6 1Z" />
  </CustomSVG>
)

export const ForwardArrowSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel}>
    <path fillRule="evenodd" clipRule="evenodd" d="M5.4 15L4 13.6L9.6 8L4 2.4L5.4 1L12.4 8L5.4 15Z" />
  </CustomSVG>
)

export const LeftArrowSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel}>
    <path d="M14 8.65686V6.65686L5.83157 6.65686L9.07422 3.41418L7.66 2L2.00315 7.65686L7.66 13.3137L9.07422 11.8995L5.83159 8.65686H14Z" />
  </CustomSVG>
)

export const SearchSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16749 9.90493C8.26803 10.5546 7.1631 10.9375 5.96875 10.9375C2.94844 10.9375 0.5 8.48906 0.5 5.46875C0.5 2.44844 2.94844 0 5.96875 0C8.98906 0 11.4375 2.44844 11.4375 5.46875C11.4375 6.6631 11.0546 7.76803 10.4049 8.66749L14.2437 12.5063L13.0063 13.7437L9.16749 9.90493ZM9.6875 5.46875C9.6875 7.52256 8.02256 9.1875 5.96875 9.1875C3.91494 9.1875 2.25 7.52256 2.25 5.46875C2.25 3.41494 3.91494 1.75 5.96875 1.75C8.02256 1.75 9.6875 3.41494 9.6875 5.46875Z"
    />
  </CustomSVG>
)

export const SearchWithEllipseSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} width="64" height="64" className={className} aria-label={ariaLabel}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54 32C54 44.1503 44.1503 54 32 54C19.8497 54 10 44.1503 10 32C10 19.8497 19.8497 10 32 10C44.1503 10 54 19.8497 54 32ZM56 32C56 45.2548 45.2548 56 32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32ZM23.337 23.337C20.221 26.4529 20.221 31.5049 23.337 34.6208C26.4529 37.7368 31.5049 37.7368 34.6208 34.6208C37.7368 31.5049 37.7368 26.4529 34.6208 23.337C31.5049 20.221 26.4529 20.221 23.337 23.337ZM21.9228 36.0351C18.0257 32.1381 18.0257 25.8198 21.9228 21.9228C25.8198 18.0257 32.1381 18.0257 36.0351 21.9228C39.6975 25.5852 39.9179 31.3861 36.6965 35.306L44.6271 43.2366L43.2129 44.6508L35.2799 36.7178C31.3604 39.9169 25.577 39.6893 21.9228 36.0351Z"
    />
  </CustomSVG>
)

export const AmbulanceSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} width="64" height="64" className={className} aria-label={ariaLabel}>
    <path d="M25 8H23V12H25V8Z" />
    <path d="M16.9289 10.5147L15.5146 11.929L18.3431 14.7574L19.7573 13.3432L16.9289 10.5147Z" />
    <path d="M31.071 10.5146L32.4853 11.9289L29.6568 14.7573L28.2426 13.3431L31.071 10.5146Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.5 26H20.5V30.5H16V37.5H20.5V42H27.5V37.5H32V30.5H27.5V26ZM18 32.5H22.5V28H25.5V32.5H30V35.5H25.5V40H22.5V35.5H18V32.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.3333 13L20.381 18H8V50H12C12 53.3137 14.6863 56 18 56C21.3137 56 24 53.3137 24 50H41C41 53.3137 43.6863 56 47 56C50.3137 56 53 53.3137 53 50H56V37L50 26H40V18H27.619L26.6667 13H21.3333ZM22.9883 15L22.4169 18H25.5831L25.0117 15H22.9883ZM10 48V20H38V48H23.6586C22.8349 45.6696 20.6124 44 18 44C15.3876 44 13.1651 45.6696 12.3414 48H10ZM54 48H52.6586C51.8349 45.6696 49.6124 44 47 44C44.3876 44 42.1651 45.6696 41.3414 48H40V38H54V48ZM40 36H53.1764L48.8127 28H40V36ZM47 54C49.2091 54 51 52.2091 51 50C51 47.7909 49.2091 46 47 46C44.7909 46 43 47.7909 43 50C43 52.2091 44.7909 54 47 54ZM22 50C22 52.2091 20.2091 54 18 54C15.7909 54 14 52.2091 14 50C14 47.7909 15.7909 46 18 46C20.2091 46 22 47.7909 22 50Z"
    />
  </CustomSVG>
)

export const MissingFileSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} width="96" height="96" aria-label={ariaLabel}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 15V81H75V30H63H60V27V15H21ZM78 30V27L63 12H60H18V84H78V30ZM73.7574 27L63 16.2426V27H73.7574ZM48 60C54.6274 60 60 54.6274 60 48C60 41.3726 54.6274 36 48 36C41.3726 36 36 41.3726 36 48C36 54.6274 41.3726 60 48 60ZM48 63C56.2843 63 63 56.2843 63 48C63 39.7157 56.2843 33 48 33C39.7157 33 33 39.7157 33 48C33 56.2843 39.7157 63 48 63ZM46.5 40.5V49.5H49.5V40.5H46.5ZM46.5 52.5V55.5H49.5V52.5H46.5Z"
    />
  </CustomSVG>
)

export const DeleteSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} width="12" height="12" className={className} aria-label={ariaLabel}>
    <path d="M4.5 0H7.5V1.5H4.5V0Z" />
    <path d="M11.25 2.25H0.75V3.75H11.25V2.25Z" />
    <path d="M8.25 10.5H3.75V4.5H2.25V12H9.75V4.5H8.25V10.5Z" />
    <path d="M6.75 4.5H5.25V9.75H6.75V4.5Z" />
  </CustomSVG>
)

export const CloseSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel}>
    <path d="M7.99999 9.41421L12.2426 13.6569L13.6568 12.2426L9.41421 8L13.6568 3.75736L12.2426 2.34315L7.99999 6.58579L3.75735 2.34315L2.34314 3.75736L6.58578 8L2.34314 12.2426L3.75735 13.6569L7.99999 9.41421Z" />
  </CustomSVG>
)

export const SuccessSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel}>
    <path
      d="M12.3048 0L4.7162 7.58864L1.70938 4.58182L0 6.2912L4.7162 11.0074L14.0142 1.70938L12.3048 0Z"
      fill="black"
    />
  </CustomSVG>
)

export const WarningSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel}>
    <path d="M9 4V9H7V4H9Z" />
    <path d="M9 12V10H7V12H9Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4182 16 8C16 3.58179 12.4183 0 8 0C3.58167 0 0 3.58179 0 8C0 12.4182 3.58167 16 8 16ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68628 11.3137 2 8 2C4.68628 2 2 4.68628 2 8C2 11.3137 4.68628 14 8 14Z"
    />
  </CustomSVG>
)

export const SavedSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} width="13" height="16">
    <path d="M10.7143 0H1.78571C0.803571 0 0.00892878 0.8 0.00892878 1.77778L0 16L6.25 13.3333L12.5 16V1.77778C12.5 0.8 11.6964 0 10.7143 0ZM10.7143 13.3333L6.25 11.3956L1.78571 13.3333V1.77778H10.7143V13.3333Z" />
  </CustomSVG>
)

export const ListSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} width="14" height="11">
    <path d="M6.3 2.149H0V3.549H6.3V2.149ZM6.3 7.749H0V9.149H6.3V7.749ZM10.038 4.949L7.56 2.471L8.547 1.484L10.031 2.968L12.999 0L14 0.987L10.038 4.949ZM10.038 10.549L7.56 8.071L8.547 7.084L10.031 8.568L12.999 5.6L14 6.587L10.038 10.549Z" />
  </CustomSVG>
)

export const StackedLineSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} width="17" height="16">
    <path d="M1.58331 13.3267L6.58331 8.32001L9.24998 10.9867L13.9766 5.67334L14.9166 6.61334L9.24998 12.9867L6.58331 10.32L2.58331 14.3267L1.58331 13.3267ZM2.58331 10.3267L6.58331 6.32001L9.24998 8.98667L14.9166 2.61334L13.9766 1.67334L9.24998 6.98667L6.58331 4.32001L1.58331 9.32667L2.58331 10.3267Z" />
  </CustomSVG>
)

export const StackedBarGraphSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} width="17" height="16">
    <path d="M4.25 6.66668H6.25V13.3333H4.25V6.66668ZM4.25 3.33334H6.25V6.00001H4.25V3.33334ZM10.9167 10.6667H12.9167V13.3333H10.9167V10.6667ZM10.9167 8.66668H12.9167V10H10.9167V8.66668ZM7.58333 8.66668H9.58333V13.3333H7.58333V8.66668ZM7.58333 6.00001H9.58333V8.00001H7.58333V6.00001Z" />
  </CustomSVG>
)

export const NoMentionsSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} width="96" height="96">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.5 67.5L82.8822 79.8823L84.2965 78.4681L73.3284 67.5H80.5H82.5V65.5V20V18H80.5H23.8284L16.4142 10.5858L15 12L21 18H17H15V20V67.5V81.2324V84L17 82.087L32.25 67.5H48.75H70.5ZM71.3284 65.5H80.5V20H25.8284L71.3284 65.5ZM23 20L68.5 65.5H48.75H32.25H31.4475L30.8676 66.0547L17 79.3194V67.5V20H23Z"
      fill="black"
      fillOpacity="0.8"
    />
  </CustomSVG>
)

export const ControlsSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} width="16" height="16">
    <path
      d="M1 11.8889V13.4444H5.66667V11.8889H1ZM1 2.55556V4.11111H8.77778V2.55556H1ZM8.77778 15V13.4444H15V11.8889H8.77778V10.3333H7.22222V15H8.77778ZM4.11111 5.66667V7.22222H1V8.77778H4.11111V10.3333H5.66667V5.66667H4.11111ZM15 8.77778V7.22222H7.22222V8.77778H15ZM10.3333 5.66667H11.8889V4.11111H15V2.55556H11.8889V1H10.3333V5.66667Z"
      fill="#5A6BAD"
    />
  </CustomSVG>
)

export const ExternalLinkSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} width="16" height="16">
    <path d="M11.8889 11.8889H4.11111V4.11111H8V3H4.11111C3.49444 3 3 3.5 3 4.11111V11.8889C3 12.5 3.49444 13 4.11111 13H11.8889C12.5 13 13 12.5 13 11.8889V8H11.8889V11.8889ZM9.11111 3V4.11111H11.1056L5.64444 9.57222L6.42778 10.3556L11.8889 4.89444V6.88889H13V3H9.11111Z" />
  </CustomSVG>
)

export const MinusSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} width="16" height="16">
    <rect x="2" y="7" width="12" height="2" fill="#F9F8F7" />
  </CustomSVG>
)

export const SouthBlackSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} width="12" height="12">
    <path d="M9.5 7.5L8.795 6.795L6.5 9.085V1H5.5V9.085L3.205 6.79L2.5 7.5L6 11L9.5 7.5Z" />
  </CustomSVG>
)

export const NorthBlackSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG
    ariaHidden={ariaHidden}
    className={className}
    aria-label={ariaLabel}
    width="12"
    height="12"
    transform={'rotate(180)'}
  >
    <path d="M9.5 7.5L8.795 6.795L6.5 9.085V1H5.5V9.085L3.205 6.79L2.5 7.5L6 11L9.5 7.5Z" />
  </CustomSVG>
)

export const PlaySvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} width="16" height="16">
    <path d="M3.5 2V14L13.5 8L3.5 2Z" />
  </CustomSVG>
)

export const ExpertsSvg = (): JSX.Element => (
  <>
    <CustomSVG>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5C16 7.76142 13.7614 10 11 10C8.23858 10 6 7.76142 6 5C6 2.23858 8.23858 0 11 0C13.7614 0 16 2.23858 16 5ZM14 5C14 6.65685 12.6569 8 11 8C9.34315 8 8 6.65685 8 5C8 3.34315 9.34315 2 11 2C12.6569 2 14 3.34315 14 5Z"
      />
      <path d="M14 14C14 13.4477 13.5523 13 13 13H9C8.44771 13 8 13.4477 8 14V16H6V14C6 12.3431 7.34315 11 9 11H13C14.6569 11 16 12.3431 16 14V16H14V14Z" />
      <path d="M5 3.12602C4.68038 3.04375 4.3453 3 4 3C1.79086 3 0 4.79086 0 7C0 9.20914 1.79086 11 4 11C4.3453 11 4.68038 10.9562 5 10.874V8.73244C4.70583 8.90261 4.36429 9 4 9C2.89543 9 2 8.10457 2 7C2 5.89543 2.89543 5 4 5C4.36429 5 4.70583 5.09739 5 5.26756V3.12602Z" />
      <path d="M2 12H5V14H2V16H0V14C0 12.8954 0.895431 12 2 12Z" />
    </CustomSVG>
    Experts
  </>
)

export const SoSVSvg = (): JSX.Element => (
  <>
    <CustomSVG>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2H14V10H12V11H11.9999V12V12.9194L10.8507 12H10.8594L8.35156 10H2V2ZM7.64546 12H0V0H16V12H13.9999V16H12.5781L7.64546 12Z"
      />
    </CustomSVG>
    SoSV
  </>
)

export const ScienceSvg = (): JSX.Element => (
  <>
    <CustomSVG>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 14L13 14V7H8V2L3 2L3 14ZM10 2.82843V5H12.1716L10 2.82843ZM10 0L15 5L15 16L1 16V0H10Z"
      />
    </CustomSVG>
    Science
  </>
)

export const PLISvg = (): JSX.Element => (
  <>
    <CustomSVG>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2222 14.2222H1.77778V1.77778H8V0H0V1.77778V16C0 16 0.791111 16 1.77778 16H16C16 16 16 15.2 16 14.2222V8H14.2222V14.2222ZM9.77778 0V1.77778H12.9689L4.23111 10.5156L5.48444 11.7689L14.2222 3.03111V6.22222H16V0H9.77778Z"
      />
    </CustomSVG>
    PLI
  </>
)

export const OKAISvg = (): JSX.Element => (
  <>
    <CustomSVG>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2222 14.2222H1.77778V1.77778H8V0H0V1.77778V16C0 16 0.791111 16 1.77778 16H16C16 16 16 15.2 16 14.2222V8H14.2222V14.2222ZM9.77778 0V1.77778H12.9689L4.23111 10.5156L5.48444 11.7689L14.2222 3.03111V6.22222H16V0H9.77778Z"
      />
    </CustomSVG>
    Accelerated Insights
  </>
)

export const UserSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG
    ariaHidden={ariaHidden}
    className={className}
    aria-label={ariaLabel}
    width="16"
    height="16"
    data-testid="user-svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 5C11 7.76142 8.76142 10 6 10C3.23858 10 1 7.76142 1 5C1 2.23858 3.23858 0 6 0C8.76142 0 11 2.23858 11 5ZM9 5C9 6.65685 7.65685 8 6 8C4.34315 8 3 6.65685 3 5C3 3.34315 4.34315 2 6 2C7.65685 2 9 3.34315 9 5Z"
      fill="#CDD5FF"
    />
    <path
      d="M10 14C10 13.4477 9.55228 13 9 13H3C2.44772 13 2 13.4477 2 14V16H0V14C0 12.3431 1.34315 11 3 11H9C10.6569 11 12 12.3431 12 14V16H10V14Z"
      fill="#CDD5FF"
    />
  </CustomSVG>
)

export const DashboardIconSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG
    ariaHidden={ariaHidden}
    className={className}
    aria-label={ariaLabel}
    width="158"
    height="32"
    data-testid="dashboard-icon-svg"
  >
    <path
      d="M43.4792 24.6976H38V7H43.6822C45.3733 7 46.822 7.3543 48.0284 8.06289C49.2347 8.76572 50.1592 9.77676 50.8018 11.096C51.4444 12.4095 51.7657 13.9822 51.7657 15.8142C51.7657 17.6577 51.4416 19.2448 50.7933 20.5756C50.1451 21.9006 49.2037 22.9203 47.9692 23.6347C46.7346 24.3433 45.238 24.6976 43.4792 24.6976ZM40.3591 22.5804H43.3439C44.7138 22.5804 45.8524 22.3125 46.76 21.7768C47.6676 21.241 48.344 20.469 48.7894 19.4609C49.2403 18.4527 49.4658 17.2372 49.4658 15.8142C49.4658 14.4085 49.2431 13.2074 48.7978 12.2108C48.3581 11.2084 47.6986 10.4422 46.8192 9.91215C45.9398 9.38214 44.8462 9.11714 43.5384 9.11714H40.3591V22.5804Z"
      fill="#1B2C57"
    />
    <path
      d="M58.7057 25C57.8827 25 57.1358 24.8416 56.4649 24.5247C55.7998 24.2079 55.2699 23.7499 54.8753 23.1507C54.4863 22.5458 54.2918 21.8084 54.2918 20.9386C54.2918 20.1839 54.4356 19.5675 54.7231 19.0893C55.0162 18.6054 55.4052 18.2252 55.89 17.9486C56.3747 17.6721 56.9131 17.4647 57.505 17.3265C58.0969 17.1882 58.6972 17.0816 59.306 17.0067C60.0896 16.903 60.7238 16.8224 61.2085 16.7648C61.699 16.7072 62.0569 16.6121 62.2824 16.4796C62.5079 16.3471 62.6206 16.1195 62.6206 15.7969V15.7278C62.6206 14.927 62.4036 14.3048 61.9695 13.8613C61.5355 13.4177 60.8844 13.1959 60.0163 13.1959C59.1144 13.1959 58.4069 13.3975 57.8939 13.8008C57.381 14.204 57.0202 14.6447 56.8116 15.1229L54.6808 14.5007C54.9908 13.6942 55.4221 13.0547 55.9745 12.5823C56.5326 12.1042 57.1555 11.7643 57.8432 11.5626C58.5366 11.3553 59.244 11.2516 59.9656 11.2516C60.4334 11.2516 60.9492 11.3092 61.5129 11.4244C62.0766 11.5338 62.6122 11.7499 63.1195 12.0725C63.6325 12.3893 64.0553 12.8589 64.3878 13.481C64.7204 14.0975 64.8867 14.9097 64.8867 15.9179V24.6976H62.6544V22.8915H62.553C62.4064 23.2026 62.1725 23.5223 61.8512 23.8507C61.5299 24.1733 61.1099 24.447 60.5913 24.6716C60.0727 24.8905 59.4441 25 58.7057 25ZM59.1285 23.047C59.8782 23.047 60.5124 22.8973 61.031 22.5977C61.5496 22.2981 61.9442 21.9093 62.2148 21.4311C62.491 20.953 62.6291 20.4431 62.6291 19.9016V18.1128C62.5389 18.2108 62.3585 18.3 62.0879 18.3807C61.8173 18.4614 61.5073 18.5305 61.1578 18.5881C60.8139 18.6457 60.4757 18.6976 60.1431 18.7436C59.8162 18.784 59.5456 18.8185 59.3314 18.8473C58.8297 18.9165 58.3646 19.0259 57.9362 19.1757C57.5134 19.3255 57.1724 19.5473 56.9131 19.8411C56.6594 20.1291 56.5326 20.518 56.5326 21.0077C56.5326 21.6817 56.7778 22.1916 57.2682 22.5372C57.7586 22.8771 58.3787 23.047 59.1285 23.047Z"
      fill="#1B2C57"
    />
    <path
      d="M77.8576 14.5353L75.8114 15.0019C75.7099 14.6966 75.5521 14.4057 75.3379 14.1291C75.1293 13.8469 74.8446 13.6135 74.4838 13.4292C74.1231 13.2448 73.6665 13.1527 73.114 13.1527C72.3587 13.1527 71.7273 13.3284 71.22 13.6798C70.7183 14.0312 70.4674 14.4777 70.4674 15.0192C70.4674 15.4916 70.6394 15.8689 70.9832 16.1512C71.3271 16.4335 71.8682 16.6668 72.6067 16.8512L74.6022 17.3351C75.7804 17.6174 76.6569 18.0552 77.2319 18.6486C77.8125 19.2362 78.1029 19.9966 78.1029 20.9299C78.1029 21.7076 77.883 22.4018 77.4433 23.0125C77.0093 23.6174 76.4033 24.0955 75.6254 24.447C74.8474 24.7984 73.9427 24.9741 72.9111 24.9741C71.5187 24.9741 70.3772 24.6687 69.4866 24.0581C68.5959 23.4417 68.0379 22.5574 67.8124 21.4052L69.9855 20.9731C70.1546 21.6587 70.4815 22.1743 70.9663 22.5199C71.4567 22.8598 72.0965 23.0298 72.8857 23.0298C73.7651 23.0298 74.4641 22.8397 74.9827 22.4594C75.507 22.0792 75.7719 21.6183 75.7776 21.0768C75.7719 20.639 75.6141 20.2732 75.304 19.9794C74.9996 19.6798 74.5289 19.4551 73.892 19.3053L71.7104 18.7955C70.5097 18.5132 69.6247 18.0667 69.0553 17.4561C68.4916 16.8397 68.2098 16.0677 68.2098 15.1402C68.2098 14.374 68.4184 13.7 68.8355 13.1181C69.2583 12.5305 69.8389 12.0725 70.5774 11.7441C71.3158 11.4157 72.1586 11.2516 73.1056 11.2516C74.4472 11.2516 75.5042 11.5511 76.2764 12.1503C77.0487 12.7494 77.5758 13.5444 77.8576 14.5353Z"
      fill="#1B2C57"
    />
    <path
      d="M83.2565 16.7648V24.6976H80.9904V7H83.2396V13.5415H83.4087C83.7075 12.8387 84.1669 12.2828 84.787 11.8737C85.4071 11.459 86.2245 11.2516 87.2391 11.2516C88.1242 11.2516 88.8993 11.4359 89.5644 11.8046C90.2352 12.1675 90.7539 12.7206 91.1203 13.4638C91.4923 14.2069 91.6783 15.1402 91.6783 16.2636V24.6976H89.4122V16.4882C89.4122 15.4743 89.1557 14.688 88.6428 14.1291C88.1354 13.5703 87.428 13.2909 86.5204 13.2909C85.8947 13.2909 85.3338 13.4263 84.8377 13.6971C84.3473 13.9678 83.9612 14.3625 83.6793 14.8809C83.3975 15.3994 83.2565 16.0274 83.2565 16.7648Z"
      fill="#1B2C57"
    />
    <path
      d="M95.4347 24.6976V7H97.7008V13.5502H97.8615C98.0081 13.3024 98.2166 12.9971 98.4872 12.6342C98.7578 12.2712 99.1383 11.9515 99.6287 11.675C100.119 11.3927 100.779 11.2516 101.607 11.2516C102.673 11.2516 103.62 11.5281 104.448 12.0811C105.277 12.6284 105.925 13.4148 106.393 14.4402C106.867 15.4599 107.103 16.6783 107.103 18.0955C107.103 19.5127 106.87 20.734 106.402 21.7595C105.934 22.7849 105.288 23.5771 104.465 24.1359C103.642 24.6889 102.698 24.9654 101.633 24.9654C100.821 24.9654 100.164 24.8272 99.6625 24.5506C99.1665 24.2741 98.7775 23.9544 98.4957 23.5915C98.2195 23.2228 98.0081 22.9059 97.8615 22.6409H97.6332V24.6976H95.4347ZM97.6586 18.061C97.6586 19.0288 97.7967 19.8814 98.0729 20.6188C98.3491 21.3505 98.7493 21.9237 99.2736 22.3385C99.8035 22.7475 100.452 22.952 101.218 22.952C102.008 22.952 102.67 22.736 103.205 22.3039C103.741 21.8718 104.144 21.2871 104.415 20.5497C104.691 19.8065 104.829 18.977 104.829 18.061C104.829 17.1565 104.694 16.3442 104.423 15.6241C104.158 14.8982 103.758 14.325 103.222 13.9045C102.687 13.4782 102.019 13.265 101.218 13.265C100.44 13.265 99.7866 13.4666 99.2567 13.8699C98.7324 14.2674 98.335 14.8262 98.0644 15.5463C97.7939 16.2664 97.6586 17.1047 97.6586 18.061Z"
      fill="#1B2C57"
    />
    <path
      d="M115.411 24.9741C114.216 24.9741 113.17 24.6889 112.274 24.1186C111.378 23.5425 110.682 22.7417 110.186 21.7163C109.689 20.6908 109.441 19.4954 109.441 18.1301C109.441 16.7475 109.689 15.5406 110.186 14.5094C110.682 13.4782 111.378 12.6774 112.274 12.1071C113.17 11.5367 114.216 11.2516 115.411 11.2516C116.606 11.2516 117.652 11.5367 118.548 12.1071C119.444 12.6774 120.141 13.4782 120.637 14.5094C121.133 15.5406 121.381 16.7475 121.381 18.1301C121.381 19.4954 121.133 20.6908 120.637 21.7163C120.141 22.7417 119.444 23.5425 118.548 24.1186C117.652 24.6889 116.606 24.9741 115.411 24.9741ZM115.411 22.9693C116.257 22.9693 116.95 22.7475 117.491 22.3039C118.038 21.8545 118.444 21.264 118.709 20.5324C118.974 19.795 119.106 18.9914 119.106 18.1215C119.106 17.2573 118.974 16.4566 118.709 15.7192C118.444 14.976 118.038 14.3797 117.491 13.9304C116.95 13.4753 116.257 13.2477 115.411 13.2477C114.571 13.2477 113.878 13.4753 113.331 13.9304C112.784 14.3797 112.378 14.976 112.113 15.7192C111.848 16.4566 111.716 17.2573 111.716 18.1215C111.716 18.9914 111.848 19.795 112.113 20.5324C112.378 21.264 112.784 21.8545 113.331 22.3039C113.878 22.7475 114.571 22.9693 115.411 22.9693Z"
      fill="#1B2C57"
    />
    <path
      d="M128.116 25C127.293 25 126.546 24.8416 125.875 24.5247C125.21 24.2079 124.68 23.7499 124.285 23.1507C123.896 22.5458 123.702 21.8084 123.702 20.9386C123.702 20.1839 123.846 19.5675 124.133 19.0893C124.426 18.6054 124.815 18.2252 125.3 17.9486C125.785 17.6721 126.323 17.4647 126.915 17.3265C127.507 17.1882 128.107 17.0816 128.716 17.0067C129.5 16.903 130.134 16.8224 130.619 16.7648C131.109 16.7072 131.467 16.6121 131.692 16.4796C131.918 16.3471 132.031 16.1195 132.031 15.7969V15.7278C132.031 14.927 131.814 14.3048 131.38 13.8613C130.945 13.4177 130.294 13.1959 129.426 13.1959C128.524 13.1959 127.817 13.3975 127.304 13.8008C126.791 14.204 126.43 14.6447 126.222 15.1229L124.091 14.5007C124.401 13.6942 124.832 13.0547 125.385 12.5823C125.943 12.1042 126.565 11.7643 127.253 11.5626C127.947 11.3553 128.654 11.2516 129.376 11.2516C129.843 11.2516 130.359 11.3092 130.923 11.4244C131.487 11.5338 132.022 11.7499 132.53 12.0725C133.042 12.3893 133.465 12.8589 133.798 13.481C134.13 14.0975 134.297 14.9097 134.297 15.9179V24.6976H132.064V22.8915H131.963C131.816 23.2026 131.582 23.5223 131.261 23.8507C130.94 24.1733 130.52 24.447 130.001 24.6716C129.483 24.8905 128.854 25 128.116 25ZM128.538 23.047C129.288 23.047 129.922 22.8973 130.441 22.5977C130.96 22.2981 131.354 21.9093 131.625 21.4311C131.901 20.953 132.039 20.4431 132.039 19.9016V18.1128C131.949 18.2108 131.769 18.3 131.498 18.3807C131.227 18.4614 130.917 18.5305 130.568 18.5881C130.224 18.6457 129.886 18.6976 129.553 18.7436C129.226 18.784 128.956 18.8185 128.741 18.8473C128.24 18.9165 127.775 19.0259 127.346 19.1757C126.923 19.3255 126.582 19.5473 126.323 19.8411C126.069 20.1291 125.943 20.518 125.943 21.0077C125.943 21.6817 126.188 22.1916 126.678 22.5372C127.169 22.8771 127.789 23.047 128.538 23.047Z"
      fill="#1B2C57"
    />
    <path
      d="M137.797 24.6976V11.4244H139.987V13.481H140.123C140.359 12.7955 140.782 12.2482 141.391 11.8392C142.005 11.4244 142.696 11.217 143.463 11.217C143.615 11.217 143.798 11.2228 144.012 11.2343C144.232 11.24 144.404 11.2516 144.528 11.2688V13.5415C144.443 13.5185 144.274 13.4897 144.021 13.4551C143.773 13.4148 143.519 13.3946 143.26 13.3946C142.645 13.3946 142.096 13.5271 141.611 13.7921C141.132 14.0514 140.754 14.4114 140.478 14.8723C140.202 15.3332 140.063 15.8574 140.063 16.445V24.6976H137.797Z"
      fill="#1B2C57"
    />
    <path
      d="M151.265 24.9654C150.2 24.9654 149.255 24.6889 148.432 24.1359C147.609 23.5771 146.964 22.7849 146.496 21.7595C146.028 20.734 145.794 19.5127 145.794 18.0955C145.794 16.6783 146.028 15.4599 146.496 14.4402C146.964 13.4148 147.612 12.6284 148.441 12.0811C149.27 11.5281 150.219 11.2516 151.29 11.2516C152.119 11.2516 152.779 11.3927 153.269 11.675C153.759 11.9515 154.14 12.2712 154.411 12.6342C154.681 12.9971 154.89 13.3024 155.036 13.5502H155.197V7H157.455V24.6976H155.256V22.6409H155.036C154.884 22.9059 154.67 23.2228 154.394 23.5915C154.117 23.9544 153.728 24.2741 153.227 24.5506C152.731 24.8272 152.077 24.9654 151.265 24.9654ZM151.679 22.952C152.446 22.952 153.091 22.7475 153.616 22.3385C154.146 21.9237 154.549 21.3505 154.825 20.6188C155.101 19.8814 155.239 19.0288 155.239 18.061C155.239 17.1047 155.104 16.2664 154.833 15.5463C154.563 14.8262 154.162 14.2674 153.633 13.8699C153.103 13.4666 152.452 13.265 151.679 13.265C150.879 13.265 150.211 13.4782 149.675 13.9045C149.14 14.325 148.737 14.8982 148.466 15.6241C148.201 16.3442 148.069 17.1565 148.069 18.061C148.069 18.977 148.204 19.8065 148.475 20.5497C148.751 21.2871 149.154 21.8718 149.684 22.3039C150.219 22.736 150.885 22.952 151.679 22.952Z"
      fill="#1B2C57"
    />
    <path d="M0 2H12V12H0V2Z" fill="#1B2C57" />
    <path d="M0 16H12V30H0V16Z" fill="#1B2C57" />
    <path d="M16 20H28V30H16V20Z" fill="#1B2C57" />
    <path d="M16 2H28V16H16V2Z" fill="#1B2C57" />
  </CustomSVG>
)

export const InsightmemeIconSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG
    ariaHidden={ariaHidden}
    className={className}
    aria-label={ariaLabel}
    width="187"
    height="32"
    data-testid="dashboard-icon-svg"
  >
    <g clipPath="url(#clip0_3092_688)">
      <path
        d="M8.62601 11.7166C8.41561 12.0793 8.20521 12.4566 8.00208 12.8484C7.69015 11.8835 7.42172 10.9041 7.20406 9.9464C6.70347 7.7264 6.44229 5.45566 6.42053 3.17763C9.1919 1.09548 12.5001 0 15.9824 0C17.0707 0 18.1589 0.108823 19.2182 0.326469C17.7816 1.29862 16.425 2.37234 15.1627 3.53312C13.6246 4.95508 12.2099 6.52213 10.9475 8.20524C10.106 9.32247 9.32972 10.505 8.62601 11.7166Z"
        fill="#1B2C57"
      />
      <path
        d="M14.7419 7.47978C15.4166 6.73252 16.1203 6.01428 16.8458 5.34684C18.5144 3.80881 20.3499 2.43764 22.3087 1.29137C26.4803 3.08332 29.7086 6.61644 31.1452 10.8968C29.5998 10.1495 28.0038 9.5184 26.3932 9.01782C24.3908 8.40116 22.3232 7.95862 20.2411 7.70465C18.8481 7.53782 17.4334 7.45076 16.0332 7.45076C15.6268 7.45076 15.1992 7.4648 14.7644 7.47905L14.7419 7.47978Z"
        fill="#1B2C57"
      />
      <path
        d="M6.72527 16.4686C5.89821 14.5315 5.24527 12.5146 4.78821 10.4833C4.41096 8.81469 4.15704 7.09526 4.03371 5.36134C1.42921 8.28509 0 12.0213 0 15.9752C0 16.6209 0.0362745 17.2666 0.116078 17.9123C2.07489 19.015 4.1643 19.9146 6.31899 20.5893C7.28385 20.8868 8.27055 21.1479 9.27898 21.3583C9.03956 20.9811 8.81469 20.6039 8.60429 20.2484C7.90778 19.0223 7.26938 17.7527 6.72527 16.4686Z"
        fill="#1B2C57"
      />
      <path
        d="M23.3679 11.7239C23.1575 11.3611 22.9327 10.9911 22.6932 10.6139C23.7017 10.8243 24.6956 11.0855 25.6604 11.3756C27.8079 12.0431 29.89 12.9427 31.8489 14.0455C31.9287 14.6766 31.9649 15.3223 31.9649 15.9607C31.9649 19.9073 30.543 23.6364 27.9457 26.5601C27.8224 24.8479 27.5685 23.1358 27.1913 21.4744C26.7342 19.4431 26.0812 17.4262 25.2542 15.4892C24.6956 14.1905 24.0644 12.9281 23.3679 11.7239Z"
        fill="#1B2C57"
      />
      <path
        d="M23.9701 19.1166C23.767 19.5084 23.5566 19.8856 23.3462 20.2484C22.6425 21.4599 21.8589 22.6425 21.0246 23.7597C19.7695 25.4356 18.3476 27.0099 16.8095 28.4319C15.5617 29.5854 14.2123 30.6519 12.7903 31.624C13.8351 31.8344 14.9087 31.9432 15.9825 31.9432C19.4794 31.9432 22.7803 30.8404 25.5589 28.7583C25.5372 26.4948 25.2687 24.2313 24.7754 22.0258C24.5505 21.0609 24.2821 20.0887 23.9701 19.1166Z"
        fill="#1B2C57"
      />
      <path
        d="M0.83429 21.0681C2.37958 21.8154 3.97564 22.4465 5.58622 22.9471C7.58129 23.5638 9.6562 24.0063 11.7384 24.2676C13.5449 24.4852 15.2932 24.5722 17.2303 24.4924C16.5556 25.2397 15.8518 25.9579 15.1264 26.6254C13.465 28.1561 11.6368 29.5128 9.69249 30.6663C5.52093 28.8744 2.27801 25.3485 0.83429 21.0681Z"
        fill="#1B2C57"
      />
      <path d="M39.6769 6.08684H41.9332V23.9773H39.6769V6.08684Z" fill="#1B2C57" />
      <path
        d="M50.5519 13.407C52.6486 13.407 53.4031 15.0103 53.4031 16.8458H53.3959V23.9773H55.5143V16.0478C55.5143 12.725 53.1637 11.4337 50.7841 11.4337C49.4202 11.4337 48.0562 12.0431 47.4178 13.1531H47.3743V11.7166H45.2559V23.9773H47.3743V17.078C47.3743 14.7492 48.5714 13.407 50.5519 13.407Z"
        fill="#1B2C57"
      />
      <path
        d="M60.0341 20.3935C60.1719 21.7138 61.2819 22.3958 62.5733 22.3958C64.4813 22.3958 64.9964 21.3583 64.9964 20.6329C64.9964 19.8348 64.4813 19.3415 62.8272 18.8917L60.687 18.304C58.8733 17.8107 58.1913 16.6064 58.1913 15.1482C58.1913 13.1241 59.7221 11.4264 62.566 11.4264C65.7001 11.4264 66.7811 13.407 66.7811 15.2425H64.8005C64.6336 13.8568 63.9299 13.1676 62.5152 13.1676C61.173 13.1676 60.3025 13.9656 60.3025 14.9306C60.3025 15.6125 60.6797 16.1276 61.6664 16.4106L64.5393 17.2376C66.4691 17.8034 67.1076 18.8627 67.1076 20.437C67.1076 22.9327 64.9166 24.253 62.6603 24.253C59.7874 24.253 58.1188 22.7223 58.0462 20.3935H60.0341Z"
        fill="#1B2C57"
      />
      <path
        d="M72.3456 7.82073C72.3456 7.00095 71.6926 6.34076 70.8656 6.34076C70.0385 6.34076 69.3784 7.00095 69.3856 7.82073C69.3856 8.64058 70.0385 9.30073 70.8656 9.30073C71.6854 9.30073 72.3456 8.64778 72.3456 7.82073Z"
        fill="#1B2C57"
      />
      <path d="M71.9248 23.9701V11.7094H69.8063V23.9701H71.9248Z" fill="#1B2C57" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.7382 11.7094H87.8567V22.2797C87.8567 26.7995 85.6873 29.15 80.9353 29.15C78.7658 29.15 76.8654 28.352 75.2182 26.5165L76.9163 25.1744C78.2073 26.7995 79.7163 27.2928 80.9862 27.2928C84.28 27.2928 85.7454 25.646 85.7454 22.9109V22.0403H85.6945C84.5411 23.426 83.344 24.1079 80.9643 24.1079C76.8436 24.1079 74.6523 20.5748 74.6523 17.7309C74.6523 14.176 77.5687 11.4192 81.0298 11.4192C82.8436 11.4192 84.6785 12.1737 85.6873 13.6319H85.7382V11.7094ZM81.4065 13.407C78.5338 13.407 76.9091 15.6923 76.9091 17.7382C76.9091 20.5603 79.1214 22.258 81.3345 22.258C83.7578 22.258 85.7382 20.3064 85.7382 17.8543C85.7382 15.3803 83.7142 13.407 81.4065 13.407Z"
        fill="#1B2C57"
      />
      <path
        d="M96.7004 13.407C98.7971 13.407 99.5513 15.0103 99.5513 16.8458L99.544 23.9773H101.663V16.0405C101.663 12.7178 99.312 11.4264 96.9324 11.4264C95.5687 11.4264 94.2044 12.0359 93.5658 13.1458H93.5222V6.08684H91.4044V23.9773H93.5222V17.078C93.5222 14.7492 94.7265 13.407 96.7004 13.407Z"
        fill="#1B2C57"
      />
      <path
        d="M105.435 8.74211H107.553V11.7094H109.505V13.5666H107.553V21.0972C107.553 21.7574 107.764 21.9895 108.591 21.9895H109.556V23.9411C109.251 23.9628 108.758 23.9628 108.265 23.9628C106.095 23.9628 105.442 23.2083 105.442 21.3293V13.5666H103.745V11.7094H105.442L105.435 8.74211Z"
        fill="#1B2C57"
      />
      <path
        d="M125.067 13.407C126.525 13.407 127.751 14.3501 127.751 16.4686V23.9773H129.869V16.2364C129.869 13.008 127.794 11.4337 125.161 11.4337C123.536 11.4337 121.911 11.9996 121.156 13.5521C120.14 11.7601 118.777 11.4337 117.529 11.4337C116.238 11.4337 114.707 11.927 114.141 13.1748H114.097V11.7166H111.979V23.9773H114.097V16.5628C114.097 14.517 115.417 13.407 117.18 13.407C118.639 13.407 119.865 14.3501 119.865 16.4686V23.9773H121.983V16.5628C121.983 14.517 123.304 13.407 125.067 13.407Z"
        fill="#1B2C57"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.858 21.5978C143.211 23.4332 141.47 24.2603 139.322 24.2603C134.969 24.2603 132.641 21.1044 132.641 17.8324C132.641 14.3501 135.137 11.4264 138.975 11.4264C142.761 11.4264 145.402 14.3211 145.402 18.6523H134.904C135.231 20.749 136.929 22.2797 139.308 22.2797C140.817 22.2797 142.159 21.576 143.24 20.2991L144.858 21.5978ZM143.001 16.9111C142.791 14.887 141.143 13.407 138.953 13.407C136.362 13.407 135.115 15.2425 134.904 16.9111H143.001Z"
        fill="#1B2C57"
      />
      <path
        d="M161.217 13.407C162.676 13.407 163.902 14.3501 163.902 16.4686V23.9773H166.02V16.2364C166.02 13.008 163.945 11.4337 161.312 11.4337C159.687 11.4337 158.062 11.9996 157.308 13.5521C156.292 11.7601 154.928 11.4337 153.68 11.4337C152.388 11.4337 150.857 11.927 150.292 13.1748H150.248V11.7166H148.13V23.9773H150.248V16.5628C150.248 14.517 151.569 13.407 153.332 13.407C154.79 13.407 156.016 14.3501 156.016 16.4686V23.9773H158.135V16.5628C158.135 14.517 159.455 13.407 161.217 13.407Z"
        fill="#1B2C57"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M181.009 21.5978C179.362 23.4332 177.621 24.2603 175.473 24.2603C171.121 24.2603 168.792 21.1044 168.792 17.8324C168.792 14.3501 171.287 11.4264 175.125 11.4264C178.912 11.4264 181.553 14.3211 181.553 18.6523H171.055C171.382 20.749 173.079 22.2797 175.459 22.2797C176.968 22.2797 178.31 21.576 179.391 20.2991L181.009 21.5978ZM179.152 16.9111C178.941 14.887 177.295 13.407 175.103 13.407C172.513 13.407 171.265 15.2425 171.055 16.9111H179.152Z"
        fill="#1B2C57"
      />
      <path
        d="M180.762 6.4642V6.89224H181.379V9.20655H181.945L181.937 6.89224H182.561V6.4642H180.762Z"
        fill="#1B2C57"
      />
      <path
        d="M186.182 9.20655V6.4642H185.514L184.615 8.53185L183.737 6.4642H183.048V9.20655H183.577V7.29127L184.404 9.20655H184.804L185.638 7.32029V9.20655H186.182Z"
        fill="#1B2C57"
      />
    </g>
    <defs>
      <clipPath id="clip0_3092_688">
        <rect width="186.182" height="32" fill="white" />
      </clipPath>
    </defs>
  </CustomSVG>
)

export const PharmaspectraIconSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG
    ariaHidden={ariaHidden}
    className={className}
    aria-label={ariaLabel}
    width="184"
    height="32"
    data-testid="dashboard-icon-svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M117.835 22.8089C118.815 22.8089 119.435 23.5156 119.614 24.71H121.201C121.049 22.4428 119.642 21.3565 117.848 21.3565C115.959 21.3565 114.511 22.4831 114.511 24.2753C114.511 25.6464 115.296 26.5828 116.911 27.1941L118.208 27.6825C119.035 27.9956 119.657 28.4712 119.657 29.1497C119.657 29.9497 118.939 30.5476 117.945 30.5476C116.649 30.5476 116.126 29.855 116.029 28.7009H114.346C114.511 30.9957 115.889 31.9999 117.876 31.9999C119.946 31.9999 121.339 30.7773 121.339 29.0543C121.339 27.7913 120.469 26.7461 118.843 26.1489L117.559 25.6747C116.649 25.3347 116.208 24.9135 116.208 24.2478C116.208 23.623 116.552 22.8089 117.835 22.8089ZM59.9062 21.5222H61.6022V31.8383H59.9062V27.3315H55.0093V31.8383H53.3126V21.5222H55.0093V25.7979H59.9062V21.5222ZM46.6947 26.9927C48.1013 26.9927 48.9156 26.3142 48.9156 24.9828C48.9156 23.6534 48.1013 22.9601 46.6947 22.9601H45.6744V26.9927H46.6947ZM43.977 21.5226H46.9985C49.3019 21.5226 50.6389 23.2187 50.6389 24.9828C50.6389 26.7892 49.2739 28.4457 46.9985 28.4457H45.6744V31.8388H43.977V21.5226ZM79.807 26.4757H78.8843V22.9597H80.3032C81.5181 22.9597 82.2483 23.653 82.2483 24.7117C82.2483 25.7152 81.6286 26.4757 79.807 26.4757ZM78.8843 31.8383V27.9018L82.7043 31.8383H85.035C84.4219 31.2148 83.7332 30.5268 83.0393 29.8337L83.0391 29.8336L83.0388 29.8332L83.0384 29.8328C82.343 29.1382 81.6425 28.4384 81.0076 27.793C82.6346 27.6297 83.945 26.4757 83.945 24.7117C83.945 22.6749 82.4278 21.5222 80.3592 21.5222H77.1869V31.8383H78.8843ZM97.421 21.5222H99.0208V31.8383H97.3241V25.0516L93.408 31.9606L89.476 25.024V31.8383H87.7793V21.5222H89.3942L93.408 28.6072L97.421 21.5222ZM126.756 26.9923C128.163 26.9923 128.976 26.3138 128.976 24.9823C128.976 23.653 128.163 22.9597 126.756 22.9597H125.735V26.9923H126.756ZM124.039 21.5222H127.059C129.362 21.5222 130.7 23.2183 130.7 24.9823C130.7 26.7887 129.335 28.4453 127.059 28.4453H125.735V31.8383H124.039V21.5222ZM138.86 21.5222H133.192V31.8383H138.86V30.3182H134.888V27.3859H138.86V25.8657H134.888V23.0416H138.86V21.5222ZM149.685 24.0032C148.927 23.2845 147.989 22.8909 147.037 22.8909C145.023 22.8909 143.216 24.4789 143.216 26.6782C143.216 28.9051 145.064 30.4663 147.037 30.4663C148.183 30.4663 149.024 29.9907 149.781 29.284L150.83 30.4925C149.824 31.402 148.471 31.9999 147.037 31.9999C143.451 31.9999 141.451 29.2302 141.451 26.6782C141.451 24.1262 143.451 21.3565 147.037 21.3565C148.54 21.3565 149.878 21.9544 150.802 22.7954L149.685 24.0032ZM153.119 23.0416H155.655V31.8383H157.352V23.0416H159.891V21.5222H153.119V23.0416ZM164.328 26.4757H165.252C167.073 26.4757 167.694 25.7152 167.694 24.7117C167.694 23.653 166.962 22.9597 165.749 22.9597H164.328V26.4757ZM164.328 27.9018V31.8383H162.633V21.5222H165.804C167.873 21.5222 169.39 22.6749 169.39 24.7117C169.39 26.4757 168.08 27.6297 166.452 27.793C167.083 28.4337 167.778 29.1279 168.468 29.8174L168.469 29.8186L168.473 29.8218L168.473 29.8224C169.171 30.5193 169.864 31.2114 170.481 31.8383H168.149L164.328 27.9018ZM69.3695 24.7541L67.4997 28.0581H71.2414L69.3695 24.7541ZM75.2867 31.8398H73.384L72.1066 29.5853H66.6345L65.3571 31.8398H63.3653L69.3695 21.4007L75.2867 31.8398ZM105.196 28.0581L107.067 24.7541L108.939 28.0581H105.196ZM107.067 21.4007L101.063 31.8398H103.054L104.331 29.5853H109.804L111.081 31.8398H112.984L107.067 21.4007ZM177.613 24.7541L175.742 28.0581H179.484L177.613 24.7541ZM171.607 31.8398L177.613 21.4007L183.529 31.8398H181.626L180.349 29.5853H174.876L173.6 31.8398H171.607Z"
      fill="#192B5A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7583 0L24.76 10.3867L5.02564 22.9271L18.7583 0ZM37.3926 32H0L3.51971 25.7789L31.5044 21.3383L37.3926 32Z"
      fill="#A02084"
    />
  </CustomSVG>
)

export const EditPencilSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} height="16" width="16">
    <mask
      id="mask0_5424_22315"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" />
    </mask>
    <g mask="url(#mask0_5424_22315)">
      <path d="M3.4 12.6H4.3832L9.9832 7L9 6.0168L3.4 11.6168V12.6ZM12.9504 6.0336L9.9664 3.0496L10.7832 2.2336C11.0611 1.95574 11.3917 1.8168 11.7752 1.8168C12.1587 1.8168 12.4891 1.95574 12.7664 2.2336L13.7664 3.2336C14.0331 3.50027 14.1664 3.83067 14.1664 4.2248C14.1664 4.61947 14.0331 4.95014 13.7664 5.2168L12.9504 6.0336ZM11.9664 7.0168L4.9832 14H2V11.0168L8.9832 4.0336L11.9664 7.0168Z" />
    </g>
  </CustomSVG>
)

export const GroupOffSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} height="16" width="16">
    <mask
      id="mask0_5612_22857"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="14"
      height="14"
    >
      <rect x="1" y="1" width="14" height="14" />
    </mask>
    <g mask="url(#mask0_5612_22857)">
      <path d="M13.4104 14.0521L10.6688 11.3104V11.8646H2.50208V11.0188C2.50208 10.7466 2.57257 10.5132 2.71354 10.3188C2.85451 10.1243 3.05139 9.96878 3.30417 9.85211C3.85833 9.60906 4.37361 9.41947 4.85 9.28336C5.32639 9.14725 5.90486 9.0792 6.58542 9.0792C7.02292 9.0792 7.40938 9.1035 7.74479 9.15211C8.08021 9.20072 8.40833 9.27364 8.72917 9.37086L6.95 7.60628C6.89167 7.616 6.8309 7.62329 6.76771 7.62815C6.70451 7.63301 6.64375 7.63545 6.58542 7.63545C6.09931 7.63545 5.69583 7.47746 5.375 7.16149C5.05417 6.84551 4.89375 6.44447 4.89375 5.95836C4.89375 5.89031 4.89618 5.82468 4.90104 5.76149C4.9059 5.69829 4.91319 5.63753 4.92292 5.5792L2.09375 2.75003L2.41458 2.41461L13.7313 13.7313L13.4104 14.0521ZM10.7708 9.22503C11.1403 9.29308 11.4927 9.37815 11.8281 9.48024C12.1635 9.58232 12.4576 9.69656 12.7104 9.82295C12.9438 9.94933 13.1333 10.1195 13.2792 10.3334C13.425 10.5473 13.4979 10.7854 13.4979 11.0479V11.8209H13.2646L11.5292 10.0709C11.4319 9.87642 11.3226 9.71114 11.201 9.57503C11.0795 9.43892 10.9361 9.32225 10.7708 9.22503ZM6.58542 9.53128C5.96319 9.53128 5.42361 9.58475 4.96667 9.6917C4.50972 9.79864 4.02361 9.98336 3.50833 10.2459C3.30417 10.3528 3.15833 10.4695 3.07083 10.5959C2.98333 10.7223 2.93958 10.8632 2.93958 11.0188V11.4125H10.2167V10.8584L9.51667 10.1584C9.04028 9.93475 8.5809 9.77433 8.13854 9.67711C7.69618 9.57989 7.17847 9.53128 6.58542 9.53128ZM8.875 7.43128C9.01111 7.22711 9.11563 7.00107 9.18854 6.75315C9.26146 6.50524 9.29792 6.24031 9.29792 5.95836C9.29792 5.62781 9.24688 5.32642 9.14479 5.0542C9.04271 4.78197 8.90903 4.52433 8.74375 4.28128C8.75347 4.28128 8.77292 4.27885 8.80208 4.27399C8.83125 4.26913 8.85556 4.2667 8.875 4.2667C9.36111 4.2667 9.76215 4.42468 10.0781 4.74065C10.3941 5.05663 10.5521 5.46253 10.5521 5.95836C10.5521 6.40558 10.4135 6.78232 10.1365 7.08857C9.85938 7.39482 9.50208 7.57225 9.06458 7.62086L8.875 7.43128ZM8.11667 6.67295L7.76667 6.32295C7.78611 6.26461 7.79826 6.20385 7.80313 6.14065C7.80799 6.07746 7.81042 6.0167 7.81042 5.95836C7.81042 5.60836 7.69375 5.31426 7.46042 5.07607C7.22708 4.83788 6.93542 4.71878 6.58542 4.71878C6.51736 4.71878 6.45417 4.72121 6.39583 4.72607C6.3375 4.73093 6.27431 4.74308 6.20625 4.76253L5.87083 4.41253C5.96806 4.37364 6.07743 4.33961 6.19896 4.31045C6.32049 4.28128 6.44931 4.2667 6.58542 4.2667C7.07153 4.2667 7.47257 4.42468 7.78854 4.74065C8.10451 5.05663 8.2625 5.46253 8.2625 5.95836C8.2625 6.08475 8.25035 6.20871 8.22604 6.33024C8.20174 6.45176 8.16528 6.566 8.11667 6.67295ZM7.53333 6.07503L6.46875 5.01045C6.48819 5.01045 6.51493 5.00558 6.54896 4.99586C6.58299 4.98614 6.61944 4.98128 6.65833 4.98128C6.90139 4.98128 7.11042 5.06878 7.28542 5.24378C7.46042 5.41878 7.54792 5.63267 7.54792 5.88545C7.54792 5.91461 7.54549 5.94621 7.54063 5.98024C7.53576 6.01426 7.53333 6.04586 7.53333 6.07503Z" />
    </g>
  </CustomSVG>
)

export const FiltersOffSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
}): JSX.Element => (
  <CustomSVG ariaHidden={ariaHidden} className={className} aria-label={ariaLabel} height="16" width="16">
    <mask
      id="mask0_5612_22858"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="14"
      height="14"
    >
      <rect x="1" y="1" width="14" height="14" />
    </mask>
    <g mask="url(#mask0_5612_22858)">
      <path d="M12.725 13.3521L2.64792 3.275L2.96875 2.96875L13.0313 13.0313L12.725 13.3521ZM3.04167 4.79167V4.33958H4.13542V4.79167H3.04167ZM4.79167 8V7.54792H7.35834V8H4.79167ZM6.25 4.79167L5.8125 4.33958H12.9583V4.79167H6.25ZM7.125 11.2083V10.7563H8.875V11.2083H7.125ZM9.45834 8L9.02084 7.54792H11.2083V8H9.45834Z" />
    </g>
  </CustomSVG>
)

export const InfoSvg = ({
  ariaHidden = false,
  className,
  ariaLabel,
  elementRef,
}: {
  ariaHidden?: boolean
  className?: string
  ariaLabel?: string
  elementRef?: RefObject<SVGSVGElement>
}): JSX.Element => (
  <CustomSVG
    aria-hidden={ariaHidden}
    width="16"
    height="16"
    className={className}
    aria-label={ariaLabel}
    elementRef={elementRef}
  >
    <mask
      id="mask0_5639_22352"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5639_22352)">
      <path
        d="M7.45391 10.4815H8.54609V7.40448H7.45391V10.4815ZM8 6.64757C8.16556 6.64757 8.30411 6.59179 8.41567 6.48023C8.52724 6.36867 8.58302 6.23011 8.58302 6.06455C8.58302 5.899 8.52724 5.76044 8.41567 5.64888C8.30411 5.53732 8.16556 5.48154 8 5.48154C7.83444 5.48154 7.69589 5.53732 7.58433 5.64888C7.47276 5.76044 7.41698 5.899 7.41698 6.06455C7.41698 6.23011 7.47276 6.36867 7.58433 6.48023C7.69589 6.59179 7.83444 6.64757 8 6.64757ZM8 13C7.30522 13 6.65591 12.8698 6.05205 12.6093C5.44819 12.3485 4.91877 11.9908 4.46379 11.5362C4.00921 11.0812 3.6515 10.5518 3.39066 9.94795C3.13022 9.34409 3 8.69478 3 8C3 7.29689 3.13022 6.64559 3.39066 6.04609C3.6515 5.4462 4.00921 4.91897 4.46379 4.46439C4.91877 4.00941 5.44819 3.6515 6.05205 3.39066C6.65591 3.13022 7.30522 3 8 3C8.70311 3 9.35441 3.13022 9.95391 3.39066C10.5538 3.6515 11.0812 4.00941 11.5362 4.46439C11.9908 4.91897 12.3485 5.44819 12.6093 6.05205C12.8698 6.65591 13 7.30522 13 8C13 8.69478 12.8698 9.34409 12.6093 9.94795C12.3485 10.5518 11.9908 11.0812 11.5362 11.5362C11.0812 11.9908 10.5518 12.3485 9.94795 12.6093C9.34409 12.8698 8.69478 13 8 13ZM8 11.7839C9.05884 11.7839 9.95411 11.4179 10.6858 10.6858C11.4179 9.95411 11.7839 9.05884 11.7839 8C11.7839 6.94116 11.4179 6.04589 10.6858 5.3142C9.95411 4.5821 9.05884 4.21606 8 4.21606C6.94116 4.21606 6.04589 4.5821 5.3142 5.3142C4.5821 6.04589 4.21606 6.94116 4.21606 8C4.21606 9.05884 4.5821 9.95411 5.3142 10.6858C6.04589 11.4179 6.94116 11.7839 8 11.7839Z"
        fill="black"
        fillOpacity="0.8"
      />
    </g>
  </CustomSVG>
)
